var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box",class:{
        'page-title-box-alt':
          _vm.layoutType !== 'vertical' && _vm.layoutType !== 'two-column',
      }},[_c('h4',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"page-title-right"},[_c('b-breadcrumb',{staticClass:"m-0",attrs:{"items":_vm.items}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }